import dayjs from 'dayjs'
import binanceIcon from 'shared/img/binance.svg'
import bybitIcon from 'shared/img/bybit.svg'
import okxIcon from 'shared/img/OKX_logo.svg'
import bitgetIcon from 'shared/img/bitget.svg'
import cmeIcon from 'shared/img/CME.svg'
import eurexIcon from 'shared/img/eurex.svg'
import sgxIcon from 'shared/img/SGX.svg'
import rithmicIcon from 'shared/img/rithmic-icon.png'

export const TIME_ZONE_OFFSET = dayjs().utcOffset() * 60

export const EXCHANGES = {
    global: [
        {
            icon: rithmicIcon,
            href: 'https://www.rithmic.com/',
        },
        {
            icon: cmeIcon,
            href: 'https://www.cmegroup.com/',
        },
        {
            icon: eurexIcon,
            href: 'https://www.eurex.com/',
        },
        {
            icon: sgxIcon,
            href: 'https://www.sgx.com/',
        },
    ],
    crypto: [
        {
            icon: binanceIcon,
            href: 'https://www.binance.com/en/register?ref=39094470',
        },
        {
            icon: bybitIcon,
            href: 'https://www.bybit.com/invite?ref=LB825P',
        },
        {
            icon: okxIcon,
            href: 'https://www.okx.com/',
        },
        {
            icon: bitgetIcon,
            href: 'https://www.bitget.com/register?ref=LB825P&from=invite%3Fref%3DLB825P',
        },
    ],
}
